import React from 'react'
import { DataTable } from '../../comp/DataTableV2'
import { Detalle, Filtros } from './contenido'
import { Messages } from '../../comp/Messages2'
import { ModalDelete } from '../../comp/ModalDelete'
import { borrarLotes, listarLotes, reactivarLotes } from '../../services/servProductos'
import { Acciones } from '../../utils/Acciones'
import { TipoDato, NivelAcceso } from '../../utils/Constantes'
import { Acceso } from '../../utils/Seguridad'
import { relativeDate2 } from '../../utils/DateUtil'
import { Traduccion } from '../../comp/Traduccion'

const vista = 'ViewLotes'

export const Lotes = () => {
    
    const tableConfig = React.useMemo(() => {
        let auxConfig = {
            title: vista,
            headers: ['TXT_NUMERO', 'TXT_PRODUCTO', 'TXT_RECEPCION', 'TXT_VENCIMIENTO'],
            types: [TipoDato.NUMERO, TipoDato.CADENA, TipoDato.FECHA, TipoDato.CADENA],
            access: ['numero', 'productoStr', 'recepcion', 'vencimientoRelativo'],
            rowId: 'id'
        }
        return auxConfig
    }, [])

    const [tData, setTData] = React.useState([])
    const [filters, setFilters] = React.useState({ codigo: null, producto: null, estadoVencimiento: 1, activo: true})
    const [isSearchOpened, setIsSearchOpened] = React.useState(false)
    const [isDetailOpened, setIsDetailOpened] = React.useState(false)
    const [isDelReacOpened, setIsDelReacOpened] = React.useState(false)
    const [isTableLoading, setIsTableLoading] = React.useState(true)
    const [seleccion, setSeleccion] = React.useState([])
    const [modalAction, setModalAction] = React.useState(Acciones().SEE)
    const [resServicio, setResServicio] = React.useState()

    //calculo permisos de acceso a la vista
    const puedeAgregar = Acceso(vista, NivelAcceso.AGREGAR)
    const puedeEditar = Acceso(vista, NivelAcceso.EDITAR)
    const puedeBorrarReinsertar = Acceso(vista, NivelAcceso.BORRAR_REINSERTAR)

    const _handleOpenSearch = () => setIsSearchOpened(true)

    const _handleOpenDetail = (action, selection) => {
        setModalAction(action)
        setResServicio()
        setSeleccion(selection ? tData.filter(e => (selection.length && selection.indexOf(e.id) > -1) || e.id === selection) : [{}])
        if ([Acciones().DEL, Acciones().REAC].includes(action)) {
            setIsDelReacOpened(true)
        } else {
            setIsDetailOpened(true)
        }
    }

    const handleSearchSubmit = (submit, filtros) => {
        setIsSearchOpened(false)
        if (submit) {
            setFilters(filtros)
        }
    }

    const handleDetailSubmit = (obj) => {
        setIsDetailOpened(false)
        setSeleccion([])
        //si viene un objeto
        if (obj) {
            let auxDatos
            if (modalAction === Acciones().ADD) { //si es alta: lo dejo solo en la tabla
                auxDatos = [obj]
            } else { //si edición: reemplazo el item seleccionado en la tabla
                auxDatos = tData.map(e => {return e.id === obj.id ? obj : e})
            }
            setTData(formatData(auxDatos))
        }
    }

    const handleDelReacSubmit = async (submit) => {
        if (!submit) return setIsDelReacOpened(false)
        let resOp = (modalAction === Acciones().DEL)
                        ? await borrarLotes(seleccion.map(e => e.id))
                        : await reactivarLotes(seleccion.map(e => e.id))
        setResServicio(resOp)
        if (resOp.status === 200) {
            setTData(tData.map(e =>
                    seleccion.some(sel => sel.id === e.id)
                        ? { ...e, activo: modalAction === Acciones().REAC }
                        : e
            ))
            setIsDelReacOpened(false)
            setSeleccion([])
        }
    }

    const formatData = (data) => {
        return data.map(e => {
            return {
                ...e,
                productoStr: e.producto.nombre,
                vencimientoRelativo: e.vencimiento ? relativeDate2(e.vencimiento, true) : Traduccion('TXT_NO_DEFINIDO')
            }
        })
    }

    React.useEffect(() => {
        setIsTableLoading(true)
        setResServicio()
        listarLotes(filters).then(resListar => {
            setIsTableLoading(false)
            if (resListar.errores) return setResServicio(resListar)
            setTData(formatData(resListar.data))
        })
    }, [filters])

    return <>
        <DataTable title={tableConfig.title}
            headers={tableConfig.headers}
            types={tableConfig.types}
            access={tableConfig.access}
            rowId={tableConfig.rowId}
            data={tData}
            openSearch={_handleOpenSearch}
            openDetail={_handleOpenDetail}
            isLoading={isTableLoading}
            hasAdd={puedeAgregar}
            hasEdit={puedeEditar}
            hasDel={puedeBorrarReinsertar}
            hasReac={puedeBorrarReinsertar} />
        <Filtros isOpen={isSearchOpened}
            onSubmit={handleSearchSubmit}
            filtros={filters} />
        <Detalle isOpen={isDetailOpened}
            onSubmit={handleDetailSubmit}
            seleccion={seleccion[0]}
            accion={modalAction} />
        <ModalDelete isOpen={isDelReacOpened}
            seleccion={seleccion.map(e => `${Traduccion('TXT_LOTE')} ${e.numero}: ${e.productoStr}`)}
            action={modalAction}
            onSubmit={handleDelReacSubmit} />
        <Messages resServicio={resServicio} accion={modalAction}/>
    </>
    
}